import axiosInstance from "../axiosInstance";

export const PUTCompletarOma = async (idomamov, confirmar) => {
  try {
    // Solo si confirmar es explícitamente true
    const confirmarSegment = confirmar === true ? "/true" : "/false";

    const url = `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/completar-oma-ope/${idomamov}${confirmarSegment}`;

    const response = await axiosInstance.put(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default PUTCompletarOma;
